import { ISupportedCurrency } from "@/api/AppApi/services/company/interfaces/ICompany";
import { createAtomWithSafeStorage } from "@/utils/atom/atomStorageUtil";
import { atom } from "jotai";

const initValue: ISupportedCurrency = {
  code: "",
  decimal_digits: 0,
  exchange_rate: 0,
  flag: "",
  name: "",
  selected: false,
  symbol: "",
};
export const currencyCodeAtom = createAtomWithSafeStorage("currencyCode", "");
export const currencyAtom = createAtomWithSafeStorage("currency", initValue);
export const getCurrentCurrencyFromCode = (
  currucies: ISupportedCurrency[],
  code: string,
) => currucies.find((c) => c.code === code);

export const currencyChangedCodeAtom = atom(false);
